import { createSelector } from 'reselect';

import type { RootState } from '@/app/store';

const selectActivityState = (state: RootState) => state.activity;

export const selectActivityItems = createSelector(selectActivityState, (s) => s.items);
export const selectActivityHasMore = createSelector(selectActivityState, (s) => s.hasMore);
export const selectActivityIsLoading = createSelector(selectActivityState, (s) => s.isLoading);
export const selectActivityOffset = createSelector(selectActivityState, (s) => s.offset);
export const selectActivityError = createSelector(selectActivityState, (s) => s.error);

export const selectHasActivePendingWithdrawal = createSelector(selectActivityState, (s) =>
  s.items.some((item) => item.type === 'WITHDRAW' && item.status === 'PENDING'),
);
